// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// Redux Form
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
// Translation
import { injectIntl, FormattedMessage } from 'react-intl';
// Redux
import { connect } from 'react-redux';
import {
  FormGroup,
  ControlLabel,
  FormControl
} from 'react-bootstrap';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';

import s from './ListPlaceStep1.css';
import bt from '../../components/commonStyle.css';

// Locale
import messages from '../../locale/messages';

// components
import FooterButton from './FooterButton';
import SidePanel from './SidePanel';

// Helpers
import validate from './validate';
import update from './update';

//Image
import toolTipIcon from '../../../public/SiteIcons/listCommonToolTip.svg';

const PROPERTY_TYPES = [
  { label: 'Apartamento', match: name => name === 'apartamento' },
  { label: 'Casa', match: name => name === 'casa' },
  { label: 'Cabaña', match: name => name === 'cabana' },
  { label: 'Glamping', match: name => name === 'glamping' },
  { label: 'Finca', match: name => name === 'finca' },
  { label: 'Hotel', match: name => name.indexOf('hotel') === 0 },
];

const normalizeOption = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

function propertyOptions(settings) {
  return PROPERTY_TYPES.map(option => {
    const setting = (settings || []).find(item => option.match(normalizeOption(item.itemName)));
    return setting && { ...setting, itemName: option.label };
  }).filter(Boolean);
}

class Page2 extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    previousPage: PropTypes.any,
    nextPage: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {
      isDisabled: true,
      houseType: [],
      roomType: [],
      buildingSize: [],
    }
  }

  UNSAFE_componentWillMount() {
    const { listingFields } = this.props;

    if (listingFields != undefined) {
      this.setState({
        houseType: listingFields.houseType,
        roomType: listingFields.roomType,
        buildingSize: listingFields.buildingSize
      });
    }
  }

  componentDidMount() {
    const { valid, buildingSizeValue, change } = this.props;
    if (![1, 2, 3, 4, 5, 6].includes(Number(buildingSizeValue))) change('buildingSize', '1');
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { valid, listingFields } = nextProps;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }

    if (listingFields != undefined) {
      this.setState({
        houseType: listingFields.houseType,
        roomType: listingFields.roomType,
        buildingSize: listingFields.buildingSize
      });
    }
    if (![1, 2, 3, 4, 5, 6].includes(Number(nextProps.buildingSizeValue))) nextProps.change('buildingSize', '1');
  }

  renderSelectField = ({ input, label, meta: { touched, error }, children }) => {
    const { formatMessage } = this.props.intl;

    return (
      <div>
        <select
          {...input}
        >
          {children}
        </select>
        {touched && error && <span>{formatMessage(error)}</span>}
      </div>
    )
  }

  renderFormControlSelect = ({ input, label, meta: { touched, error }, children, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormControl componentClass="select" {...input} className={className} >
          {children}
        </FormControl>
      </div>
    )
  }

  render() {
    const { handleSubmit, previousPage, nextPage, existingList, formPage, step } = this.props;
    const { formatMessage } = this.props.intl;
    const { isDisabled, houseType, roomType } = this.state;
    const visibleHouseTypes = propertyOptions(houseType);
    const visibleRoomTypes = roomType.filter(value => value.isEnable == 1 && normalizeOption(value.itemName) !== 'habitacion compartida');
    let path = "index";
    if (existingList) {
      path = "home";
    }

    return (
      <div>
        <div className={s.grid}>
          <SidePanel
            title={formatMessage(messages.stepOneCommonHeading)}
            landingContent={formatMessage(messages.whatKindOfPlaceListing)}
          />
          <div>
            <form onSubmit={handleSubmit}>
              <div>
                <div className={s.landingMainContent}>
                  <FormGroup className={s.space5}>
                    <ControlLabel className={cx(s.landingLabel, 'textWhite')}>
                      <FormattedMessage {...messages.whatTypeOfProperty} />
                    </ControlLabel>
                    <Field name="houseType" component={this.renderFormControlSelect} className={cx(s.formControlSelect, s.listCommonJumboSelect, 'listCommonJumboSelectRTL')}>
                      {
                        visibleHouseTypes.map((value, key) => {
                          return (
                            <option value={value.id} key={key}>{value.itemName}</option>
                          )
                        })
                      }
                    </Field>
                  </FormGroup>
                  <FormGroup className={s.space5}>
                    <ControlLabel className={cx(s.landingLabel, 'textWhite')}>
                      <FormattedMessage {...messages.whatGuestHave} />
                    </ControlLabel>
                    <Field name="roomType" component={this.renderFormControlSelect} className={cx(s.formControlSelect, s.listCommonJumboSelect, 'listCommonJumboSelectRTL')}>
                      {
                        visibleRoomTypes.map((value, key) => {
                          return (
                            value.isEnable == 1 && <option value={value.id} key={key}>{value.itemName}</option>
                          )
                        })
                      }
                    </Field>
                  </FormGroup>
                  <FormGroup className={s.space5}>
                    <ControlLabel className={cx(s.landingLabel, 'textWhite')}>
                      <FormattedMessage {...messages.howManyRooms} />
                    </ControlLabel>
                    <Field name="buildingSize" component={this.renderFormControlSelect} className={cx(s.formControlSelect, s.listCommonJumboSelect, 'listCommonJumboSelectRTL')} >
                      {
                        [1, 2, 3, 4, 5, 6].map(value => <option value={String(value)} key={value}>{value}</option>)
                      }
                    </Field>
                  </FormGroup>
                  <FormGroup className={s.space5}>
                    <ControlLabel className={cx(s.landingLabel, 'textWhite')}>
                      <FormattedMessage {...messages.isPersonalHome} />
                    </ControlLabel>
                    <Field name="residenceType" component={this.renderFormControlSelect} className={cx(s.formControlSelect, s.listCommonJumboSelect, 'listCommonJumboSelectRTL')}>
                      <option value={"1"} >{formatMessage(messages.yesText)}</option>
                      <option value={"0"} >{formatMessage(messages.noText)}</option>
                    </Field>
                  </FormGroup>
                  <div className={s.tipCommonCss}>
                    <img src={toolTipIcon} />
                    <span className={cx(s.commonTipCsss, 'textWhite')}><FormattedMessage {...messages.isPersonalHomeInfo} /></span>
                  </div>
                </div>
                <FooterButton
                  isDisabled={isDisabled}
                  nextPage={nextPage}
                  previousPage={previousPage}
                  nextPagePath={"bedrooms"}
                  previousPagePath={path}
                  formPage={formPage}
                  step={step}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

Page2 = reduxForm({
  form: 'ListPlaceStep1', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
  onSubmit: update
})(Page2);

// Decorate with connect to read form values
const selector = formValueSelector('ListPlaceStep1'); // <-- same as form name

const mapState = (state) => ({
  existingList: state.location.isExistingList,
  listingFields: state.listingFields.data,
  buildingSizeValue: selector(state, 'buildingSize'),
});

const mapDispatch = { change };

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(Page2)));
